/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendarPlanning = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M7 4V2h2v2h6V2h2v2h5v8.31l-2-1.155V6h-3v2h-2V6H9v2H7V6H4v14h7.072v.268c0 .63.198 1.234.55 1.732H2V4zm12 6v.636a3 3 0 0 0-2 0V10zm-3 0v1.155L14.536 12H14v-2zm-5 3h1.804l-.232.134A3 3 0 0 0 11.162 15H11zm0 3h.072v2H11zm-4-4H5v-2h2zm3-2v2H8v-2zm3 2h-2v-2h2zm-6 3H5v-2h2zm3-2v2H8v-2zm-3 5H5v-2h2zm3-2v2H8v-2zm8.53-3.848a1 1 0 0 0-1.06 0l-4 2.5a1 1 0 0 0-.47.848v4a1 1 0 0 0 .47.848l4 2.5a1 1 0 0 0 1.06 0l4-2.5A1 1 0 0 0 23 19.5v-4a1 1 0 0 0-.47-.848zM17 20.196l-2-1.25v-1.642l2 1.25zm4-2.892v1.642l-2 1.25v-1.642zm-.887-1.804L18 16.82l-2.113-1.32L18 14.18z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCalendarPlanning as CalendarPlanning };
